import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginPage } from '@/pages/login'

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    // Redirect to dashboard if already authenticated
    const token = localStorage.getItem('auth_token')
    if (token) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  component: LoginPage,
})
